import React from 'react';
import { SelectOption } from 'global';
import { Control } from 'react-hook-form';
import { Box, Stack } from '@mui/material';
import { AutocompleteValueField, DateField } from 'components/form';
import { DealActivityStatus } from '@trnsact/trnsact-shared-types';
import { convertEnumToSelectOptions } from 'utils/selectOptionsHelper';

import { ActivityListFilters } from '../types';

interface Props {
  ownerOptions: SelectOption[];
  opportunityOptions: SelectOption[];
  control: Control<{ filters: ActivityListFilters }>;
}

const FIELD_SX = { flex: 1, minWidth: 0 };

export const EventFilterFields = ({ control, ownerOptions, opportunityOptions }: Props) => (
  <Stack direction="row" alignItems="center" gap="0.5rem">
    <Box sx={FIELD_SX}>
      <AutocompleteValueField
        multiple
        size="small"
        control={control}
        options={convertEnumToSelectOptions(DealActivityStatus)}
        name="filters.eventFilters.status"
        textFieldProps={{ label: 'Status', variant: 'outlined' }}
      />
    </Box>

    <Box sx={FIELD_SX}>
      <AutocompleteValueField
        size="small"
        control={control}
        options={ownerOptions}
        name="filters.eventFilters.ownerId"
        textFieldProps={{ label: 'Owner', variant: 'outlined' }}
      />
    </Box>

    <Box sx={FIELD_SX}>
      <AutocompleteValueField
        size="small"
        control={control}
        options={opportunityOptions}
        name="filters.eventFilters.opportunityId"
        textFieldProps={{ label: 'Opportunity', variant: 'outlined' }}
      />
    </Box>

    <Box sx={FIELD_SX}>
      <DateField
        label="From"
        control={control}
        name="filters.eventFilters.dateFrom"
        slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
      />
    </Box>

    <Box sx={FIELD_SX}>
      <DateField
        label="To"
        control={control}
        name="filters.eventFilters.dateTo"
        slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
      />
    </Box>
  </Stack>
);
